import type { TravellerDetailsFlight, TravellerDetailsResponse } from '@/types/amendTraveller'

type TravellerConfigDaysMap = TravellerDetailsResponse['configDaysMap']

/**
 * Promotional / offer block on a sector — onward OR return (when RT with two flights).
 */
export function travellerDetailsHasPromotionalOffer(data: {
  flightList: TravellerDetailsFlight[]
  isRt: boolean
  configDaysMap?: TravellerConfigDaysMap
}): boolean {
  const flights = data?.flightList
  if (!flights?.length) return false
  const map = data?.configDaysMap
  if (map?.[String(flights[0]?.id)]?.isOffer) return true
  if (
    data?.isRt &&
    flights.length > 1 &&
    map?.[String(flights[1]?.id)]?.isOffer
  ) {
    return true
  }
  return false
}

/**
 * Trip-level flags from configDaysMap (mirrors typical isGdsIntlTrip-style checks).
 */
export function deriveGdsIntlSmsFlags(
  flightList: TravellerDetailsFlight[] | undefined,
  configDaysMap: TravellerConfigDaysMap | undefined
): { isGdsIntl: boolean; isSms: boolean } {
  if (!flightList?.length) {
    return { isGdsIntl: false, isSms: false }
  }
  let anyGdsIntl = false
  let allSms = true
  for (const flight of flightList) {
    const sector = configDaysMap?.[String(flight?.id)]
    if (!sector) {
      allSms = false
      continue
    }
    if (sector?.isGdsIntl) anyGdsIntl = true
    if (!sector?.isSms ) allSms = false
  }
  return { isGdsIntl: anyGdsIntl, isSms: allSms }
}

/**
 * Numeric tier for GDS intl post-load auto case (§7). Prefer API `eligibilityTier` when present.
 * Returns undefined when sectors are missing from configDaysMap or trip is not GDS intl + non-SMS.
 */
export function computeSectorAmendTier(
  flightList: TravellerDetailsFlight[] | undefined,
  configDaysMap: TravellerConfigDaysMap | undefined,
  isFullyAmmendable: boolean | undefined
): number | undefined {
  if (!flightList?.length) return undefined
  for (const flight of flightList) {
    if (configDaysMap?.[String(flight?.id)] == null) return undefined
  }
  const { isGdsIntl, isSms } = deriveGdsIntlSmsFlags(flightList, configDaysMap)
  if (!isGdsIntl || isSms) return undefined
  return isFullyAmmendable ? 4 : 2
}
